import { render } from "./SidebarMobile.vue?vue&type=template&id=7bb667ea&scoped=true&ts=true"
import script from "./SidebarMobile.vue?vue&type=script&lang=ts"
export * from "./SidebarMobile.vue?vue&type=script&lang=ts"

import "./SidebarMobile.vue?vue&type=style&index=0&id=7bb667ea&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb667ea"]])

export default __exports__